import { RecipeBoxesPageFull } from '../recipe-boxes/recipe-boxes.full';
import { RecipeBoxDataGateway } from '../../providers/recipe-box-data-gateway';
//import { CategoryArray } from 'ionic-native/dist/es5';
import { RecipeData } from '../../providers/recipe-data';
import { Component } from '@angular/core';
//import { EventCodes, FireBaseObjectNames, LocalStorageCodes } from '../../../../core/codes';
import { UserData } from '../../../../providers/user-data';
import { Events, LoadingController, NavController, NavParams } from 'ionic-angular';
import { PageBaseFull } from '../../../../core/page-base.full';
import { AppSettings } from '../../../../config/app-settings';
import { RecipeCommon } from './recipe.common';
import { Storage } from '@ionic/storage';
import { AngularFireDatabaseWrapper } from '../../../../providers/angularfire-wrapper';
//import { Utils } from '../../../../providers/utils';
import { RecipeDetailPageFull } from '../recipe-detail/recipe-detail.full';
//import { ElasticResult } from '../../../../providers/elastic-search'; 
import 'rxjs/add/operator/combineAll';
import 'rxjs/add/operator/mergeAll';


@Component({
	selector: 'page-recipe-full',
	templateUrl: 'recipe.full.html'
})
export class RecipePageFull extends PageBaseFull {
	public recipesList: any;
	public recipeCategories: any;
	public loader: any;
	public userRecipes = [];
	public recipeBoxData: any;
	public userId = '';
	public categoryUrlSlug = 'all';
	public category: any;
	public pageSize: Number = 5;
	public pageIndex: Number = 0;
	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public common: RecipeCommon,
		public events: Events,
		public storage: Storage,
		public afw: AngularFireDatabaseWrapper,
		public loadingCtrl: LoadingController,
		public recipeData: RecipeData,
		public recipeBoxGateway: RecipeBoxDataGateway,
		private navParams: NavParams
	) {
		super(settings, events, nav, userData);
		this.categoryUrlSlug = navParams.get('categoryUrlSlug');

	}
	ngAfterViewInit() {

	}
	ionViewDidEnter() {
		this.loader = this.loadingCtrl.create();
		//this.common.commonMethod();
		this.userId = this.currentUser ? this.currentUser.uid : null;
		this.recipeBoxData = this.recipeBoxGateway.getService(this.userId);
		this.loadData();


	}
	public loadData() {
		this.loader.present();
		// if(self.categoryUrlSlug && self.categoryUrlSlug != '' && self.categoryUrlSlug != 'all'){
		this.getAllCategoriesData().subscribe(categoriesRes => {
			this.loader.dismiss();
			console.log(categoriesRes, this.categoryUrlSlug);
			this.category = _.find(categoriesRes, (value: any, key) => {
				return value.urlSlug == this.categoryUrlSlug;
			});
			console.log(this.category);
			if (!this.category)
				this.category = { $key: 'All', name: 'All' };
			this.getRecipesData().subscribe(result => {
				console.log(result);
			})
		});


	}

	// public getRecipesByCategory(category) {
	// 	this.categoryUrlSlug = category.urlSlug;
	// 	this.getLocalRecipes().then(recipes => {
	// 		if (recipes) {
	// 			this.recipesList = _.filter(recipes, recipe => {
	// 				return _.find(recipe['categories'], (value, key) => {
	// 					return key == category.$key;
	// 				});
	// 			});
	// 		}
	// 	});
	// }
	// public getLocalRecipes() {
	// 	return this.recipeData.getLocalRecipes();
	// }
	// public getAllRecipes() {
	// 	Observable.from([this.getAllRecipesData(), this.getAllCategoriesData()]).combineAll().subscribe(() => {

	// 	});
	// }
	public changPage(pageIndex) {
		this.pageIndex = pageIndex;
		console.log(pageIndex);
		this.getRecipesData().subscribe(result => {
			console.log(result);
		})
	}
	public getRecipesData() {
		// this.categoryUrlSlug = 'all';
		// this.category = { $key: 'All', name: 'All' };
		return this.recipeData.getRecipesFullData(this.category.$key,'', this.userId, this.pageSize, this.pageIndex).map(recipes => {
			this.recipesList = recipes;
			console.log(recipes);

			// this.saveRecipesToLocalStorage();
			return recipes;
		});
	}
	public getAllCategoriesData() {
		return this.recipeData.getAllCategories().map(recipeCategories => {
			if (recipeCategories) {
				this.recipeCategories = recipeCategories;
			}
			return recipeCategories;
		});
	}

	//select favorite
	addOrRemoveUserRecipe(recipe) {
		if (!recipe.isFavorite) {
			this.recipeBoxData.add(this.userId, recipe).then(userRecipe => {
				recipe.isFavorite = true;
			});

		}
		else {
			this.recipeBoxData.remove(this.userId, recipe).then(result => {
				if (result)
					recipe.isFavorite = false;
			});
		}

	}
	// getUserRecipeKeys(recipeId) {
	// 	var favoriteRecipes = _.filter(this.userRecipes, function (userRecipe: any) {
	// 		return userRecipe.recipeId === recipeId;
	// 	});
	// 	favoriteRecipes = _.map(favoriteRecipes, '$id');
	// 	if (favoriteRecipes)
	// 		return favoriteRecipes;
	// 	return [];
	// }
	public selectRecipeBox() {
		this.nav.push(RecipeBoxesPageFull, {});
	}
	//Recipe detail
	viewRecipeDetail(recipe) {
		console.log(recipe);
		this.nav.push(RecipeDetailPageFull, { categoryUrlSlug: this.categoryUrlSlug, id: recipe.$id ? recipe.$id : recipe.$key });
	}

	viewRecipeCategory(categoryUrlSlug) {
		if (!categoryUrlSlug)
			categoryUrlSlug = 'all';
		this.nav.push(RecipePageFull, { categoryUrlSlug: categoryUrlSlug });
	}
}



// WEBPACK FOOTER //
// ./src/modules/recipes/pages/recipe/recipe.full.ts